import { render, staticRenderFns } from "./AlVerticalNavigation.vue?vue&type=template&id=23bdbcb9&scoped=true&"
import script from "./AlVerticalNavigation.vue?vue&type=script&lang=js&"
export * from "./AlVerticalNavigation.vue?vue&type=script&lang=js&"
import style0 from "./AlVerticalNavigation.vue?vue&type=style&index=0&id=23bdbcb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bdbcb9",
  null
  
)

export default component.exports